module.exports = __webpack_public_path__ + "img/imagecloseicon.a2e92db7.svg";